import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { addNote, createNote } from '../Actions/actions'


const mapStateToProps = (state) => {
  return {
    state: state
  }
}

class AddNote extends React.Component {
  constructor(props) {
    super(props);
    const { dispatch } = this.props
    dispatch(createNote('CREATE'))
  }

  saveNote = e => {
    e.preventDefault()
    const { dispatch } = this.props
    const newNote = {
      message: e.target.message.value,
      issue: e.target.issue.value,
      location: e.target.location.value,
      created: new Date().getTime()
    }
    dispatch(addNote(newNote))
    dispatch(createNote())
  }

  render() {
    const placeholderMessage = "Dolore landjaeger consequat, quis sirloin aliqua corned beef salami esse nulla beef ribs. Aliqua magna exercitation ribeye, fugiat incididunt prosciutto strip steak pork loin dolore reprehenderit nostrud venison cillum. Eu ham hock cillum picanha ground round. Consequat est chuck, pastrami dolore ut beef corned beef labore turducken leberkas ham officia. Consectetur eiusmod flank corned beef cillum veniam. Pork belly labore drumstick mollit. Veniam ground round t-bone voluptate, cow salami spare ribs sed alcatra.";

    const { appState } = this.props.state

    let notesLink
    if (appState.creating === false) {
      notesLink = <div className="notification is-info"><p>You can view your <Link className="is-link is-large" to="notes">new note</Link> or just create another one.</p></div>
    }

    return (

      <section className="section">
        <div className="container">

          <h1 className="title">
            {appState.creating ? "Create New Field Note" : "Add Another New Note"}
          </h1>

          <h2 className="subtitle">
            {appState.creating ? "You can create new notes, even when offline." : "Keep adding notes. We will sync them later"}
          </h2>

          <form onSubmit={this.saveNote} className="content">
            <div className="field">
              <label className="label">Location</label>
              <p className="control">
                <span className="select">
                  <select name="location">
                    <option>NW Soy</option>
                    <option>N Soy</option>
                    <option>NE Soy</option>
                    <option>S Soy</option>
                    <option>SW Soy</option>
                  </select>
                </span>
              </p>
            </div>

            <div className="field">
              <label className="label">Issue</label>
              <p className="control">
                <span className="select">
                  <select name="issue">
                    <option>General Note</option>
                    <option>Grasshoppers</option>
                    <option>Crop circles</option>
                    <option>Weeds</option>
                  </select>
                </span>
              </p>
            </div>

            <div className="field">
            <label className="label">Detail</label>
            <p className="control">
              <textarea
                className="textarea"
                placeholder="Textarea"
                name="message"
                defaultValue={placeholderMessage}
                required
              ></textarea>
            </p>
            </div>

            <div className="field is-grouped">
            <p className="control">
              <button type="submit" className="button is-primary">Submit Note</button>
            </p>
            <p className="control">
              <Link className="is-link button" to="notes">Cancel to all notes</Link>
            </p>
            </div>
          </form>
          <hr />
          {notesLink}
        </div>
      </section>
    )
  }
}
export default connect(mapStateToProps)(AddNote)



// WEBPACK FOOTER //
// ./src/Pages/create.js